import request from "@/utils/request";

export function getNavigation() {
  return request.get("/api/navigation");
}

export function getHome() {
  return request.get("/api/home");
}

export function getSite() {
  return request.get("/api/site");
}

export function getSitePage(pageKey) {
  return request.get(`/api/site/pages/${pageKey}`);
}

export function getSiteSection(section) {
  return request.get(`/api/site/${section}`);
}

export function getBusinesses() {
  return request.get("/api/businesses");
}

export function getHistory() {
  return request.get("/api/history");
}

export function getNews(params) {
  return request.get("/api/news", { params });
}

export function getNewsDetail(id) {
  return request.get(`/api/news/${id}`);
}

export function submitMessage(data) {
  return request.post("/api/messages", data);
}
